import { RoomInfoActionTypes } from './types';

export const storeRoomInfo = (data: any) => ({
  type: RoomInfoActionTypes.STORE_DATA,
  payload: {
    data,
  },
});
